import { FormBuilder, FormGroup } from '@angular/forms';
import {
    MyAllElemContributoAssociativoEntity,
    MyAllElemContributoRevPrecEntity,
    MyRTRigaCalcoloMoraSanzione,
    MyVerbale,
} from '../../../../models/interfaces/revisione.interface';
import { rebuildFormArray } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

export const buildContribAssociativoFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    // ordinamento in place sul clone: populateForm fa patchValue per indice con lo stesso array, un ordinamento su copia andrebbe perso
    const contribAssociativo = (myVerbale?.my_AllContributoAssociativo?.my_AllElemContributoAssociativo ?? []).sort(
        (a, b) => parseInt(a.my_Anno, 10) - parseInt(b.my_Anno, 10) || parseInt(a.my_NumRata, 10) - parseInt(b.my_NumRata, 10)
    );
    rebuildFormArray(fb, contribAssociativo, form, 'my_AllContributoAssociativo.my_AllElemContributoAssociativo', buildContribAssociativoGroup);
};

export const buildContribAssociativoGroup = (fb: FormBuilder, item?: MyAllElemContributoAssociativoEntity): FormGroup => {
    return fb.group({
        my_Anno: { value: item?.my_Anno, disabled: true },
        my_NumRata: { value: item?.my_NumRata, disabled: true },
        my_TotDovuto: { value: item?.my_TotDovuto, disabled: true },
        my_TotVersato: { value: item?.my_TotVersato, disabled: true },
        my_Diff: { value: item?.my_Diff, disabled: true },
    });
};

export const buildContribRevPrecFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const contribRevPrec = (myVerbale?.my_AllContributoRevPrec?.my_AllElemContributoRevPrec ?? []).sort(
        (a, b) => parseInt(b.my_Biennio, 10) - parseInt(a.my_Biennio, 10)
    );
    rebuildFormArray(fb, contribRevPrec, form, 'my_AllContributoRevPrec.my_AllElemContributoRevPrec', buildContribRevPrecGroup);
};

export const buildContribRevPrecGroup = (fb: FormBuilder, item?: MyAllElemContributoRevPrecEntity): FormGroup => {
    return fb.group({
        my_Biennio: { value: item?.my_Biennio, disabled: true },
        my_DovAccNot: { value: item?.my_DovAccNot, disabled: true },
        my_TotaleDovuto: { value: item?.my_TotaleDovuto, disabled: true },
        my_TotaleVersato: { value: item?.my_TotaleVersato, disabled: true },
        my_Diffe: { value: item?.my_Diffe, disabled: true },
    });
};

export const buildVersamentoFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const contoCorrentePrevisto = myVerbale?.my_SezioneI__Rilevazione?.my_ContributoBiennale?.my_ContoCorrentePrevistoPerVersamento;
    const elencoVersamenti = myVerbale?.my_RTCalcoloMoraSanzione?.my_RTRigaCalcoloMoraSanzione;
    rebuildFormArray(fb, elencoVersamenti, form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione', (fbb, item) => {
        const group = buildVersamentoGroup(fbb, item);
        if (isNilOrEmpty(group.get('my_NumeroContoCorrente').value)) {
            group.get('my_NumeroContoCorrente').setValue(contoCorrentePrevisto);
        }
        return group;
    });
};

export const buildVersamentoGroup = (fb: FormBuilder, item?: MyRTRigaCalcoloMoraSanzione): FormGroup => {
    return fb.group({
        my_id_mezzoPagamentoContributoRevisione: item?.my_id_mezzoPagamentoContributoRevisione ?? '',
        my_DataVersamento: item?.my_DataVersamento ?? '',
        my_ImportoVersamento: item?.my_ImportoVersamento ?? '',
        my_IbanOrdinante: item?.my_IbanOrdinante ?? '',
        my_NumeroAssegno: item?.my_NumeroAssegno ?? '',
        my_NumeroContoCorrente: item?.my_NumeroContoCorrente ?? '',
        my_AltroMezzoPagamento: item?.my_AltroMezzoPagamento,
    });
};
